<template>
  <div>
    <!--resp menu -->
    <section class="all-categories-side bg-color-theme4 pt-3 text-right">
      <div class="d-flex align-items-center justify-content-between">
        <div class="flex-grow-1">
          <router-link style="width: 80px;" class="d-flex justify-content-center mr-3" to="/"
            ><img class="w-100 h-100 menu-logo" src="@/assets/images/logo2.png" alt=""
          /></router-link>
        </div>
        <button
          type="button"
          class="bg-none pl-4 text-color-theme-dark rounded"
          @click="allCategoriesToggle()"
        >
          <CloseSvg width="30" />
        </button>
      </div>
      <div class="accordion mt-3 px-4" id="accordionExample">
        <div
          v-for="item in menu"
          :key="item.id"
          class="bg-color-theme4 border-bottom px-2 mb-2 py-2"
        >
          <div class="card-header d-flex gap-10" id="headingOne">
            <a
              v-if="item.new_tab || item.link"
              :target="item.new_tab ? '_blank' : '_self'"
              :href="
                $router.resolve(
                  findUrl(
                    item.linkable_type,
                    item.linkable_id,
                    item.slug,
                    item.link
                  )
                ).href
              "
              @click="close"
              class="d-flex text-color-theme-dark font-w-500 font-s-14"
            >
              <span
                class="circle-list bg-color-theme8 rounded-circle mt-1 ml-2"
              ></span>
              {{ item.title }}
            </a>
            <router-link
              v-else
              @click.native="close"
              class="d-flex text-color-theme-dark font-w-500 font-s-14"
              :to="
                $router.resolve(
                  findUrl(
                    item.linkable_type,
                    item.linkable_id,
                    item.slug,
                    item.link
                  )
                ).href
              "
            >
              <span
                class="circle-list bg-color-theme8 rounded-circle mt-1 ml-2"
              ></span>
              {{ item.title }}
            </router-link>
            <button
              v-show="item.children.length != 0"
              @click="(e) => rotateArrow(e.currentTarget)"
              class="all-categories-side-btn with-event collapsed bg-transparent"
              type="button"
              data-toggle="collapse"
              :data-target="'#mobileMenuChild' + item.id"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5025 6.6827C15.5025 6.5402 15.45 6.3977 15.3375 6.2852C15.12 6.0677 14.76 6.0677 14.5425 6.2852L9.65252 11.1752C9.29252 11.5352 8.70752 11.5352 8.34752 11.1752L3.45751 6.2852C3.24001 6.0677 2.88001 6.0677 2.66251 6.2852C2.44501 6.5027 2.44501 6.86269 2.66251 7.08019L7.55252 11.9702C7.93501 12.3527 8.45252 12.5702 9.00002 12.5702C9.54752 12.5702 10.065 12.3602 10.4475 11.9702L15.3375 7.08019C15.4425 6.96769 15.5025 6.8252 15.5025 6.6827Z"
                  fill="#787171"
                />
              </svg>
            </button>
          </div>
          <div
            v-show="item.children.length != 0"
            :id="'mobileMenuChild' + item.id"
            class="sub-all-categories-side-btn text-right collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body py-0">
              <ul class="all-categories-sub-menu">
                <li v-for="child in item.children" :key="child.id" class="mb-2">
                  <div class="d-flex gap-8">
                    <a
                      v-if="child.new_tab || child.link"
                      @click="close"
                      :target="child.new_tab ? '_blank' : '_self'"
                      class="text-color-theme-dark font-w-500 font-s-14"
                      :href="
                        $router.resolve(
                          findUrl(
                            child.linkable_type,
                            child.linkable_id,
                            child.slug,
                            child.link
                          )
                        ).href
                      "
                      >{{ child.title }}</a
                    >
                    <router-link
                      v-else
                      @click.native="close"
                      :target="child.new_tab ? '_blank' : '_self'"
                      class="text-color-theme-dark font-w-500 font-s-14"
                      :to="
                        findUrl(
                          child.linkable_type,
                          child.linkable_id,
                          child.slug
                        )
                      "
                    >
                      {{ child.title }}
                    </router-link>
                    <button
                      v-show="child.children.length != 0"
                      @click="(e) => rotateArrow(e.currentTarget)"
                      class="all-categories-side-btn with-event collapsed bg-none"
                      type="button"
                      data-toggle="collapse"
                      :data-target="'#mobileMenuChildChild' + child.id"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="mb-1"
                      >
                        <path
                          d="M15.5025 6.6827C15.5025 6.5402 15.45 6.3977 15.3375 6.2852C15.12 6.0677 14.76 6.0677 14.5425 6.2852L9.65252 11.1752C9.29252 11.5352 8.70752 11.5352 8.34752 11.1752L3.45751 6.2852C3.24001 6.0677 2.88001 6.0677 2.66251 6.2852C2.44501 6.5027 2.44501 6.86269 2.66251 7.08019L7.55252 11.9702C7.93501 12.3527 8.45252 12.5702 9.00002 12.5702C9.54752 12.5702 10.065 12.3602 10.4475 11.9702L15.3375 7.08019C15.4425 6.96769 15.5025 6.8252 15.5025 6.6827Z"
                          fill="#787171"
                        />
                      </svg>
                    </button>
                  </div>
                  <div
                    v-show="child.children.length != 0"
                    :id="'mobileMenuChildChild' + child.id"
                    class="sub-all-categories-side-btn text-right collapse"
                    aria-labelledby="headingOne"
                  >
                    <div class="card-body py-0 px-2">
                      <ul class="all-categories-sub-menu">
                        <li
                          v-for="childChild in child.children"
                          :key="childChild.id"
                        >
                          <a
                            v-if="childChild.new_tab || childChild.link"
                            @click="close"
                            :target="childChild.new_tab ? '_blank' : '_self'"
                            class="text-color-theme-dark font-w-500 font-s-14"
                            :href="
                              $router.resolve(
                                findUrl(
                                  childChild.linkable_type,
                                  childChild.linkable_id,
                                  childChild.slug,
                                  childChild.link
                                )
                              ).href
                            "
                            >{{ childChild.title }}</a
                          >
                          <router-link
                            v-else
                            @click.native="close"
                            :target="childChild.new_tab ? '_blank' : '_self'"
                            class="text-color-theme-dark font-w-500 font-s-14"
                            :to="
                              findUrl(
                                childChild.linkable_type,
                                childChild.linkable_id,
                                childChild.slug
                              )
                            "
                          >
                            {{ childChild.title }}
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 d-flex justify-content-center mt-4">
        <SocialNetworks />
      </div>
    </section>
    <!--resp menu button-->
    <div class="all-categories-resp" @click="allCategoriesToggle()"></div>
    <!-- close menu by click to body-->
  </div>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";
import CloseSvg from "@/components/svgs/CloseSvg";
import SocialNetworks from "@/parts/Front/components/shared/SocialNetworks.vue";

export default {
  name: "RespMenu",
  components: { CloseSvg, SocialNetworks },
  watch: {},
  methods: {
    gotoCategoryAndClose(id, slug) {
      this.$router.push({
        name: "product.category",
        params: { category: id, slug: slug },
      });
      this.allCategoriesToggle();
    },
    close() {
      setTimeout(() => {
        let hasClassClose = document
          .getElementById("all-categories")
          .classList.contains("all-categories-close");
        if (hasClassClose) {
          this.allCategoriesToggle();
        }
      }, 200);
    },
    findUrl,
    allCategoriesToggle() {
      document
        .getElementById("all-categories")
        .classList.toggle("all-categories-close");
      let hasClassClose = document
        .getElementById("all-categories")
        .classList.contains("all-categories-close");
      let catSide = document.getElementsByClassName("all-categories-side")[0];
      let allCategoriesResp = document.querySelectorAll(
        ".all-categories-resp"
      )[0];

      // let wrapper = document.getElementsByClassName('wrapper')[0];
      if (hasClassClose) {
        window.addEventListener("popstate", this.checkBackButton);
        this.$router.push(this.$route.fullPath + "#resp-menu");
        catSide.style.right = "0px";
        allCategoriesResp.style.display = "block";
        // if(window.screen.width >= 1200){
        // wrapper.style.paddingRight="250px";
        // }
      } else {
        // if(window.screen.width >= 1200){
        //     wrapper.style.paddingRight="0";
        // }
        catSide.style.right = "-103%";
        allCategoriesResp.style.display = "none";
        this.$router
          .replace(this.$route.fullPath.replace("#resp-menu", ""))
          .catch((e) => {});
        window.removeEventListener("popstate", this.checkBackButton);
      }
    },
    rotateArrow(el) {
      el.children.forEach((child) => {
        if (child.classList.contains("d-none")) {
          child.classList.remove("d-none");
        } else {
          child.classList.add("d-none");
        }
      });
    },
    checkBackButton() {
      this.allCategoriesToggle();
    },
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("popstate", this.checkBackButton);
  },
  computed: {
    // دریافت منو ها از ویو ایکس
    menu() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"];
      } else {
        return this.$store.getters["front/getHomeData"].menu.header;
      }
    },
    // دریافت دسته بندی ها ازویوایکس
    category() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"];
      } else {
        return this.$store.getters["front/getHomeData"].categories;
      }
    },
  },
};
</script>
<style scoped></style>
